import RaffleOcrActivityContent from "./RaffleOcrActivityContent";

export default RaffleOcrActivityContent;